export default {
  common: {
    country: "国家",
    city: "城市",
    currency: "币种",
    search: "查询",
    reset: "重置",
    postCode: "邮政编码",
    address: "地址",
    id: "编号",
    stockLocation: "Stock Location",
    stockLocation2: "库存所在地名称",
    action: "操作",
    remove: "删除",
    plzInput: "请输入",
    plzSelect: "请选择",
    plzEnterSelect: "请输入并选择",
    plzAdd: "请添加",
    cancel: "取消",
    ok: "确定",
    yes: "是",
    no: "否",
    fullFormTip: "请补全信息",
    submitSuccess: "提交成功",
    systemError: "系统错误",
    successful: "操作成功",
    startMonth: "开始月份",
    endMonth: "结束月份",
    expandAllConditions: "展开所有条件",
    putAway: "收起",
    month: "月",
    week0: "周一",
    week1: "周二",
    week2: "周三",
    week3: "周四",
    week4: "周五",
    week5: "周六",
    week6: "周日",
    add: "新增",
    id2: "ID",
    name: "名称",
    status: "状态",
    edit: "编辑",
    open: "开启",
    disable: "停用",
    email: "邮箱",
    message: "提示",
    submit: "提交",
    confirmDelete: "确认删除吗？",
    save: "保存",
    back: "返回",
    day: "天",
    tooLong: "太长了",
    validateEmail: "请输入正确的邮箱",
  },
  crm: {
    domesticPayment: "境内付款",
    overseaPayment: "境外付款",
    phoneNumber: "手机号码",
    payMethod: "付款方式",
    defaultOption: "是否默认",
    idNumber: "身份证号",
    provideRetailPrice: "是否提供吊牌价",
    exportfields: "导出字段",
    saleArea: "销售区域",
    selectVendorStockType: "请选择库存接入方式",
    selectSystemName: "请选择系统名称",
    selectVendorGeography: "请选择买手店所在地区",
    selectVendorCurrency: "请选择店铺币种",
    processingComplete: "处理完成",
    submit: "提交",
    cancel: "取消",
    orderNotifyStatus: "订单通知状态",
    portfields: "商品导入导出字段",
    orderFields: "订单导入/导出字段",
    selectGeography: "请选择区域",
    geography: "区域",
    selectSystem: "请选择买手店使用的系统",
    vendorId: "店铺ID",
    storeCode: "店铺编码",
    vendorName: "店铺名称",
    vendorAlias: "店铺别名",
    vendorStoreStatus: "买手店状态",
    vendorStartDate: "开店时间（日）",
    vendorInfoLastUpdateTime: "店铺信息更新时间（日）",
    vendorType: "买手店类型",
    vendorRegion: "业务运营区域",
    saleChannels: "上架渠道",
    vendorGeography: "买手店所在国家/区域",
    vendorLicenceLocation: "买手店营业执照地点",
    vendorCode: "店铺Code",
    systemName: "系统名称",
    stockConnectivityMethod: "库存接入方式",
    productConnectivityMethod: "商品数据对接方式",
    pricingConnectivityMethod: "价格接入方式",
    imRepresentative: "商家负责BD",
    imAssistantRepresentative: "初级BD",
    preSaleAvailablity: "是否支持预售",
    editStatus: "编辑状态",
    basicInfo: "基本信息",
    payment: "支付信息",
    billingInfo: "商家发票信息",
    billingInfo2: "发票信息",
    vendorContacts: "商家联络人",
    needAudit: "（需要审核）",
    otherSaleChannelInfo: "其他渠道业务",
    fulfillment: "履约信息",
    vendorEventParticipation: "活动情况",
    imBusinessStatus: "IM业务",
    vendorStockStatus: "货品信息",
    shipmentStockLocationInfo: "物流&发货地信息",
    vendorInfo: "店铺信息",
    contractOrSLASigned: "是否有合同orSLA",
    shippingMethods: "物流方式",
    vendorsShippingCountry: "支持发货国家",
    vat: "国家税率",
    vendorEvaluation: "买手店评价",
    vendorsPartnership: "商家对IM合作的定义",
    salesSatisfaction: "对IM满意度（批发业务）",
    mpSalesSatisfaction: "对IM满意度（MP业务）",
    techInfo: "技术配置信息",
    paymentMethod: "业务付款方式",
    depositAmount: "押金&预付款金额（RMB）",
    paymentTiming: "业务付款周期",
    settlementCycle: "结算周期",
    otherPaymentTiming: "请输入其他付款周期",
    paymentRemark: "备注其他付款形式及金额",
    vendorSettlementCurrency: "店铺结算币种配置",
    pricingInfo: "商家价格信息",
    retailPriceIncludesTax: "吊牌价是否含税",
    vendorLoginAccount: "登录账号",
    supplyPriceIncludesTax: "供货价是否含税",
    provideHangingPrice: "是否提供吊牌价",
    ifIMCanGetTaxBack: "商家是否能退税",
    companyName: "公司名称",
    vatNumber: "增值税号",
    contactPerson: "联系人",
    contactEmail: "联系邮箱",
    contactPhoneNumber: "联系电话",
    payeeInfo: "商家收款信息",
    payeeName: "收款人名称",
    bankName: "银行名称",
    bankAccount: "银行账号",
    swiftCode: "SWIFT代码",
    iban: "IBAN号码",
    bankAddress: "银行地址",
    mainContactName: "姓名",
    mainContactTitle: "职位",
    mainContact: "联系方式",
    mainContactReponseSpeed: "回复速度",
    mainContactResponsiblefor: "负责内容分类",
    mainContactNegotitationStyle: "沟通习惯与负责内容描述",
    visitInfo: "拜访信息",
    quarterlyF2FVisitFrequency: "季度面对面拜访频次",
    otherVisitingFrequency: "其他拜访习惯",
    otherInfo: "其他联络信息",
    mainContactIMOrderEmail: "买手店订单推送邮箱",
    retailStore: "线下店",
    hasRetailStore: "是否有线下店",
    hasRetailStore1: "是",
    hasRetailStore0: "否/不清楚",
    retailStoreScale: "线下店规模(数量&分布)",
    retailStoreName: "名称",
    retailStoreAddress: "地址",
    retailStoreYears: "店铺成立时长",
    retailStoreAnnualSales: "年销售额(RMB)",
    retailStoreSalesContribution: "年销售额占比%",
    otherSalesChannels: "其他销售渠道",
    otherSalesChannels2: "列举除Farfetch和得物以外的其他销售渠道",
    ecWebsite: "官网 or APP",
    hasEcWebsite: "是否有商家销售官网 or APP",
    wholesaleBusiness: "批发业务",
    hasWholesaleBusiness: "是否有批发业务",
    farfetch: "Farfetch渠道",
    hasFarfetch: "是否有Farfetch的销售渠道",
    dewu: "得物渠道",
    hasDewu: "是否有得物的销售渠道",
    yearsOfOperatation: "建立时长",
    annualSales: "年销售额(RMB)",
    salesContribution: "年销售额占比%",
    sourceOfGoods: "买手店货源（进货渠道）",
    mpProfitExpectation: "期望利润率（MP业务）",
    profitExpectation: "期望利润率（批发业务）",
    stockLocationId: "库存所在地ID",
    stockLocationName: "库存所在地名称",
    shipFromStockLocation: "实际发货地",
    stockValidPeriod: "库存有效期",
    fullClearPercentage: "全量清零占比",
    skuCodeAskeyCode: "接入Sku Code唯一编码",
    isCo: "是否支持当季CO拆分",
    switchOfFullClared: "全量清零开关",
    fullGoods: "商品全量",
    fullStock: "库存全量",
    personalSellerIMID: "个人卖家关联用户ID",
    addPayeeInfo: "添加收款信息",
    editPayeeInfo: "编辑收款信息",
    vendorContactsInfo: "商家联络信息",
    addVendorContact: "添加联系人",
    editVendorContact: "编辑联系人",
    formOfCommunication: "联系形式",
    contactNumber: "联系号码",
    addContactInfo: "添加联系方式",
    addRetailStore: "添加线下店",
    rollingPreSale: "滚动预售",
    supportPreSale: "支持",
    notSupportPreSale: "不支持",
    auditStatus0: "商家信息审核中",
    auditStatus1: "审核通过",
    auditStatus2: "已驳回",
    selectMainStore: "选择关联的主店",
    taxRefund: "能",
    noTaxRefund: "不能",
    sureDelContact: "确认删除该条商家联系人信息？",
    needAddedAfterDel: "删除后需要重新添加",
    doYouContinue: "，你还要继续吗",
    copyVendor: "一键复制",
    selectVendor: "选择买手店",
    copyRelatedStoreInfo: "复制关联店铺信息",
    submitAudit: "提交审核",
    saveAudit: "保存和提交审核",
    cancelEdit: "取消编辑",
    effectiveAfterAudit: "审核后生效",
    infoCompletion: "信息填写完成度",
    requiredFieldCompletion: "必填字段完成度",
    groupName: "集团名称",
    parentCompanyName: "母公司名",
    businessEntityName: "业务主体名称",
    passTheAudit: "审核通过",
    dismiss: "驳回",
    auditSubmitTip:
      "提示：审核通过后，修改内容生效；驳回后编辑修改内容不生效，可重新提交修改",
    auditPassTip: "通过后修改的内容立即生效",
    auditDismiss: "驳回后修改的内容不生效",
    auditPassTip2: "通过后申请的内容立即生效",
    auditDismiss2: "驳回后申请的内容不生效",
    auditPassConfirmTip: "确认审核通过吗？",
    auditDismissConfirmTip: "确认驳回申请吗？",
    vendorCurrency: "店铺币种",
    editAudit: "编辑审核",
    applicant: "申请人",
    applyTime: "申请时间",
    editcontent: "编辑内容",
    viewVendorInfo: "查看商家信息",
    editVendorInfo: "编辑商家信息",
    reEdit: "重新编辑",
    audit: "去审核",
    respondSpeedForFulfillmentIssues: "履约问题反应速度（买手店回复速度)",
    salesFulfillment: "总履约订单数 (YTD)",
    canceledOrders: "累计取消占比（YTD）",
    serviceScore: "服务指数（YTD）",
    mistakeAndDamagedOrders: "累计错漏瑕占比（YTD）",
    delayOrders: "累计延迟发货占比（YTD）",
    avgServiceScoreArea: "本区域的平均服务指数（YTD）",
    serviceScoreRankingArea: "商家在本区域服务指数排名（YTD）",
    serviceScoreTrendGraph: "服务指数趋势图（月维度）",
    last3Years: "近3年",
    lastYear: "去年",
    thisYear: "今年",
    allEvents: "全部活动",
    participated: "已参加",
    promotionDesc: "活动详情",
    promotionName: "活动名称",
    promotionTime: "活动时间",
    whetherParticipate: "是否参加",
    createdList: "已创建",
    creatingList: "新店创建中",
    storeBuildStatus: "建店状态",
    auditStore: "审核建店信息",
    setTechInfo: "技术信息配置",
    reApplyBuildStore: "重新申请建店",
    editTechInfo: "编辑技术信息",
    startBusiness: "开始营业",
    suspensionBusiness: "暂停营业",
    updateStatusToPending: "切回准备中",
    apiPermissionConf: "接口权限配置",
    checkLogisticsConf: "是否完成物流配置",
    currency: "店铺币种",
    deadlineForDay: "截单时间",
    confirmTimeFromMerchant: "最迟confirm时间",
    shippingDeadline: "最迟ship时间",
    orderShippingDay: "发货日",
    operationType: "运营类型",
    notifyEmailSettings: "通知邮箱设置",
    afterSaleNotifyEmail: "售后邮件通知邮箱",
    workOrderAutoEmai: "工单自动邮件",
    workOrderAutoEmailSettings: "工单自动邮件设置",
    vendorOrderPushEmail: "买手店订单推送邮箱",
    using: "使用中",
    terminated: "已停用",
    enable: "启用",
    shut: "关闭",
    orderPushTime: "推送时间",
    pushEmailContent: "邮件内容",
    addPushEmail: "添加邮箱",
    orderNotifyEmail: "订单通知地址",
    taxIncluded: "含税",
    taxExcluded: "不含税",
    support: "支持",
    notSupport: "不支持",
    lookAgain: "再看看",
    applyCreateStore: "申请创建新店",
    contractTime: "签约时间",
    registedCompanyName: "公司名称",
    registeredCompanyName: "注册公司名称",
    areaCode: "区号",
    afterSaleNotifyEmailSetting: "售后邮件通知邮箱",
    canInputEmailsMost: "您最多可以添加10个邮件地址",
    orderEmailTime: "通知时间",
    orderEmailTip: "已创建订单将在以下时间发送到邮箱",
    orderEmailTip2: "最多可选择5个通知时间",
    timeZone: "时区",
    selectOrderTime: "选择通知时间",
    emailFormatIncorrect: "邮箱格式不正确",
    addTime: "添加时间",

    imBusinessStatusDesc: "IM业务情况",
    currGmv: "年至今GMV",
    mpGrossRate: "MP业务毛利率（%）",
    omsGrossGate: "批发业务毛利率（%）",
    currSuborderQty: "年至今售出件数",
    mpGmvAddYear: "MP 业务年至今 GMV",
    currGmvRank: "GMV在IM的排名",
    gmvIncreaseRateRank: "GMV增长%排名 (YOY)",
    currSuborderQtyRank: "年至今售出件数排名",
    suborderQtyIncreaseRateRank: "年至今售出件数增长排名 (YOY)",
    wholesale1GmvAddYear: "现货批发 1.0 年至今 GMV",
    wholesale2GmvAddYear: "现货批发 2.0 年至今 GMV",

    gmvGraph: "GMV变动趋势 (weekly)",
    top10BrandList: "商家GMV前10品牌",
    brandListState: "（取近半年 (180天) 的GMV数据）",
    brandName: "品牌名",
    gmvRank: "商家GMV排名",
    brandRank: "品牌在IM平台上的GMV排名",

    goVendorHistory: "点击跳转风神查看更多数据",
    curGmv: "当前GMV",
    preGmv: "去年同期GMV",
    curOrders: "当前订单数",
    preOrders: "去年同期订单数",
    submitStoreInfo: "提交建店信息",
    pleaseSelectReviewer: "请选择审核人",
    selectReviewer: "选择审核人",
    storeReviewer: "建店审核人",
    storeType: "建店类型",
    salesRegion: "销售区域",
    orderDeadLine: "截单时间",
    orderConfirm: "最迟confirm时间",
    shipDeadline: "最迟ship时间",
    shipDay: "发货日",
    orderNoticeLink: "订单通知链接",
    orderNoticeStatus: "订单通知状态",
    incorrectPostalCodeFormat: "邮政编码格式不正确",
    goodsInfo: "货品信息",
    totalStockValue: "在售货值 & Ranking",
    dailyNewStock: "日均推货货值 & Ranking（一个月维度）",
    soltOutRank: "商家在IM上个月售罄率 & Ranking",
    newStockFre: "推货频次（次/月）",
    stockStatus07: "0-7级商品占比",
    level: "第{0}名",
    former: "原",
    conductor: "处理人",
    changeRequest: "申请修改",

    logisticsRelated: "物流相关",
    tmsLogisticsRoute: "TMS物流路线",
    logisticsType: "物流方式",
    expressConfig: "快递配置",
    logisticsSettlementMethod: "物流结算方式",
    fullFormLogisticsRelatedTip: "请补全物流相关",
    fullFormStockLocationTip: "请补全StockLocation",
    transferWarehouseName: "中转仓名称",
    fullFormPaymentTip: "请补全支付信息",
    parentBranchStore: "是否子母店",
    branchStore: "子店",
    parentStore: "母店",
    parentStoreName: "母店名称",

    wholesaleV2Conf: "批发2.0专项配置",
    wholesaleField1: "下集货单店铺",
    wholesaleField2: "同步库存店铺",

    tempStorage: "暂存",
    allowCategoryMappingFail: "是否允许类目mapping失败",
    addPortalOperator: "增加portal操作员",
    portalOperator: "portal操作员",
    afterSalesInfoManage: "履约售后信息维护",
    afterSaleAging: "售后时效",
    returnTimeLimit: "退货时效限制",
    whetherToAcceptAfterSales: "是否接受售后",
    notAcceptedAfterSalesType: "不接受售后类型",
    notAcceptedAfterSalesCases: "不接受瑕疵的售后案例",
    SevenDayNoReasonReturn: "是否支持七天无理由",
    ShowNoReasonAfterSaleImage: "是否展示无理由售后图片",
    show: "展示",
    notShow: "不展示",
    notAcceptedAfterSalesCategories: "不接受售后的品类",
    portalVersion: "portal版本",
    orderOperationMode: "订单操作模式",
    packingBoxMode: "打包装箱模式",
    logisticsMode: "物流运输模式",
    stockErrorProblem: "库存易错问题点",
    priceErrorProblem: "价格易错问题点",
    performanceBottleneck: "履约瓶颈",
    afterSaleSituation: "履约售后情况",
    workLog: "工作日志",
    techConfChanges: "技术配置更改",
    logChangeType: "更改类型",
    logChangeContent: "更改内容",
    logChangeTime: "更改时间",
    logVisitType: "拜访类型",
    logVisitDate: "拜访日期",
    logVisitPurpose: "拜访目的",
    logComeToAgreement: "达成协议",
    logRemark: "备注",
    logVisitPeopel: "拜访人",
    addVisitRecord: "添加拜访记录",
    visitRecord: "拜访日志",
    officialWebsite: "官网地址",
    destroyStore: "注销店铺",
    confirmDestroyStore: "当前店铺符合注销条件，确认注销该店铺？",
    unclaimedBalanceStatus: "存在未提现余额",
    unSettlementOrderStatus: "存在未结算订单",
    unSettlementAmountStatus: "存在未结算金额",
    storeCannotBeDestroyed: "当前店铺不可被注销",
    vendorSaleAfterAddressInfo: "商家退货信息",
    receiveUserName: "收件人",
    receivePhone: "电话",
    receiveEmail: "邮箱",
    receivePostCode: "邮编",
    receiveVatNum: "税号",
    receiveAddressCountry: "国家",
    receiveAddressCity: "城市",
    receiveAddress: "地址",
    addAddressInfo: "添加收货信息",
    editAddressInfo: "修改收货信息",
    portalPriceAdjustment: "系统店铺portal调价",
    supportAftersalesPriceReduction: "支持售后降价",
    vendorStageRuleRow: "售后周期列数",
    daysOfAftersalePriceReductionCycle: "售后降价周期天数",
    supportReserve: "是否支持预订",
    batchUpdateBD: "批量更改BD",
    batchUpdateBDTip: "保存之后就会更改当前选中的店铺的BD",
    technicalContact: "技术联系人",
    batchSelectVendor: "批量选择买手店",
    batchEnterVendorTip: "请输入买手店名称（一行一个，最多1000个）：",
    batchVendorNotExistTip: "以下买手店不存在：",
    batchVendorReverseTip: "勾中此框，表示选中除以下买手店以外的所有买手店",
    batchVendorLimitTip: "输入行数不允许超过1000，请重新输入",
    copyInvoiceFrom: "复制发票信息和支付信息，从",
    addFast: "禁售",
    deleteFast: "移出禁售",
    batchSelectVendorId: "批量选择买手店Id",
    batchEnterVendorIdTip: "请输入买手店Id（一行一个，最多1000个）：",
    batchVendorIdNotExistTip: "以下买手店Id不存在：",
    openSettlement: "开通结算",
    closeSettlement: "关闭结算",
    confirmCloseSettlement: "确认关闭该店铺的结算功能？",
    confirmOpenSettlement: "确认开通该店铺的结算功能？",
    openSettlementSuccess: "结算功能开通成功",
    closeSettlementSuccess: "已关闭结算功能",
  },
};
